import { createSelector } from '@ngrx/store';
import { SeatKind, TellentApps } from '@tellent/types';

import { createEntityCollectionStore, memoizeSelector } from '@recruitee/ngrx';

import { EntityStoreKey } from '../types';

const idSelector = ({ guid }: { guid: string }) => guid;

const { actions, selectors, reducer, namespace } = createEntityCollectionStore<TellentApps>()(
  EntityStoreKey.TellentApps,
  {
    idSelector,
  },
);

const appsTypeSelector = createSelector(selectors.entities(), (data): SeatKind[] =>
  data.map(({ kind }) => kind),
);

export const selectRolesSelectOptions = memoizeSelector((seatKind: SeatKind) =>
  createSelector(
    selectAppBySeatKind(seatKind),
    app =>
      app?.roles.map(({ externalId, name }) => ({
        label: name,
        value: externalId,
      })) || [],
  ),
);

export const selectAppBySeatKind = memoizeSelector((seatKind: SeatKind) => {
  const selector = selectors.entities();
  return createSelector(selector, apps => apps.find(app => app.kind === seatKind));
});

const TellentAppsSelectors = {
  ...selectors,
  selectRolesSelectOptions,
  selectAppBySeatKind,
  appsTypeSelector,
};

export {
  actions as TellentAppsActions,
  TellentAppsSelectors,
  reducer as TellentAppsReducer,
  namespace as TellentAppsNamespace,
};
